export default {
  allSystemPermissions(state) {
    return state.allSystemPermissions;
  },

  authedUserPermissions(state) {
    return state.authedUserPermissions;
  },
};
